import { IReportDimension } from '~/src/dash/apiV2/reporting/reportTypes';

export const REPORTING_MAX_SELECTED_CHARS = 65;

export interface IDimensionListItem extends IReportDimension {
  selected: boolean;
}

export enum IncludeExcludeStatus {
  NONE = 0,
  INCLUDE,
  EXCLUDE,
}

export interface IOrderBy {
  key: string;
  direction: OrderByDirections;
}

export type OrderByDirections = 'Descending' | 'Ascending';

export interface IDimensionListItem extends IReportDimension {
  selected: boolean;
}

export interface IReportFilterState {
  key: string;
  selected: string[]; // ['12', '14', ...] for dropdowns. ['text-input'] for text input filters (always of length 1)
  includeExcludeStatus: IncludeExcludeStatus;
  isHideInactive: boolean;
}
